var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FairyRes } from '../supports/FairyRes';
import { Panel } from './Panel';
export class AsyncPanel extends Panel {
    constructor(resName, uiName, panelName) {
        super(null, panelName);
        this._isLoading = false;
        this._resName = resName;
        this._uiName = uiName;
    }
    load() {
        const _super = Object.create(null, {
            show: { get: () => super.show }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (this._isReady || this._isLoading)
                return;
            this._isLoading = true;
            if (this._preRes) {
                this._preRes.forEach((item) => __awaiter(this, void 0, void 0, function* () {
                    yield FairyRes.getPackageRes(item).loadAll();
                }));
            }
            const pkgRes = FairyRes.getPackageRes(this._resName);
            yield pkgRes.loadAll();
            this._pkg = pkgRes.getPkg();
            if (this._pkg) {
                const oper = new fgui.AsyncOperation();
                oper.createObject(this._pkg.name, this._uiName);
                oper.callback = Laya.Handler.create(this, (skin) => {
                    this._isLoading = false;
                    this.onResReady();
                    this.skin = skin;
                    if (this._isShow) {
                        _super.show.call(this);
                    }
                });
            }
            else {
                this.onResError();
                if (this._isShow) {
                    this._isShow = false;
                }
            }
            this._isLoading = false;
        });
    }
    onResReady() {
        //
    }
    onResError() {
        //
    }
    show() {
        if (!this.canShow())
            return;
        if (this._isReady) {
            super.show();
            return;
        }
        this._isShow = true;
        if (this._isLoading)
            return;
        this.load();
    }
}
